//countDown
(function ($, Drupal, once) {
	'use strict';

	Drupal.behaviors.countDown = {
		attach: function (context, settings) {


				console.log('countDown.js loaded');
			const countDownTimer = () => {
				const countDownElements = document.querySelectorAll(".counter-wrapper");

				countDownElements.forEach(element => {
					timer(element);
				});

				function updateTimeElement(timeElement, num) {
					const numString = num.toString();
					timeElement.innerHTML = '';
					for (const digit of numString) {
						const span = document.createElement('span');
						span.textContent = digit;
						timeElement.appendChild(span);
					}
				}

				function timer(el) {
					// Set the date we're counting down to
					const unixTimestampString = el.dataset.countDownTo;
					const unixTimestamp = parseInt(unixTimestampString, 10);
					const countDownDate = new Date(unixTimestamp * 1000);

					if (isNaN(countDownDate)) return;

					function updateTimeElements() {
						// Get today's date and time
						const now = new Date().getTime();

						// Find the distance between now and the count down date
						const distance = countDownDate - now;

						// Time calculations for days, hours, minutes and seconds
						let days = Math.floor(distance / (1000 * 60 * 60 * 24));
						let hours = Math.floor(
							(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
						);
						let minutes = Math.floor(
							(distance % (1000 * 60 * 60)) / (1000 * 60)
						);
						let seconds = Math.floor((distance % (1000 * 60)) / 1000);

						// Add leading zeros when number is < 10 (if needed)
						if (days < 10) {
							days = "0" + days;
						}
						if (hours < 10) {
							hours = "0" + hours;
						}
						if (minutes < 10) {
							minutes = "0" + minutes;
						}
						if (seconds < 10) {
							seconds = "0" + seconds;
						}

						// If the countdown is finished, stop timer and set values to zero
						if (distance < 0) {
							clearInterval(x);
							days = "0" + 0;
							hours = "0" + 0;
							minutes = "0" + 0;
							seconds = "0" + 0;
							// Reload the page when the timer ends
							location.reload();
						}

						// Display the result in the elements
						updateTimeElement(el.querySelector("[data-days]"), days);
						updateTimeElement(el.querySelector("[data-hours]"), hours);
						updateTimeElement(el.querySelector("[data-minutes]"), minutes);
						updateTimeElement(el.querySelector("[data-seconds]"), seconds);

					}

					const x = setInterval(function () {
						updateTimeElements();
					}, 1000);
				}
			};

			countDownTimer();

		}
	};
})(jQuery, Drupal);

